module.exports = __webpack_public_path__ + "static/img/campoco-1.8c52994.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/campoco-1.jpg
// module id = bBx5
// module chunks = 1